import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { resetModel } from '../../store/components/modelSlice';

const LanguageShow = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);
    
    const cancelHandler = () => dispatch(resetModel());

    return (
        <Modal show={ true } centered>
            <Modal.Header>View Info</Modal.Header>
            <Modal.Body>
                <div className="subject-container ql-bubble">
                    <div className='html-edit-container ql-editor' dangerouslySetInnerHTML={{__html: data}}></div>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ cancelHandler }>Close</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default LanguageShow;